import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import {
  B2cCallbackRequest,
  B2cCallbackRequestListResponse,
  B2cCallbackRequestStatusFilter
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class B2cCallbackService {
  createdGW = this.socket.fromEvent<B2cCallbackRequest>('b2c_callback_created');

  updatedGW = this.socket.fromEvent<B2cCallbackRequest>('b2c_callback_updated');

  constructor(private readonly http: HttpClient, private readonly socket: Socket) {}

  getPending(params: { limit?: number; offset?: number } = {}) {
    return this.http.get<B2cCallbackRequestListResponse>(
      `${environment.BACKEND}/b2c-callbacks/pending`,
      {
        params: {
          limit: params.limit || 20,
          offset: params.offset || 0
        }
      }
    );
  }

  getJournal(
    params: { status?: B2cCallbackRequestStatusFilter; limit?: number; offset?: number } = {}
  ) {
    const requestParams: Record<string, string | number> = {
      limit: params.limit || 100,
      offset: params.offset || 0
    };

    if (params.status && params.status !== 'ALL') {
      requestParams.status = params.status;
    }

    return this.http.get<B2cCallbackRequestListResponse>(
      `${environment.BACKEND}/b2c-callbacks/journal`,
      {
        params: requestParams
      }
    );
  }

  complete(id: number, result?: { outcome: string; note: string }) {
    return this.http.post<B2cCallbackRequest>(
      `${environment.BACKEND}/b2c-callbacks/${id}/complete`,
      result || null
    );
  }
}
